import { TRoute } from "@/shared/types/route";
import AlertsWorkspaceLayout from "./pages/alerts-workspace-layout";
import AlertsQueuePage from "./pages/alerts-queue-page";
import AlertsHistoryPage from "./pages/alerts-history-page";
import AlertsAnalyticsPage from "./pages/alerts-analytics-page";
import AlertsMonitoringPage from "./pages/alerts-monitoring-page";
import { ALERTS_URL } from "./config/alerts-urls";

/**
 * The workspace is one layout with several modes. Queue is the index route — an
 * operator opening "Alerts" wants the work that needs deciding, not a search.
 */
const ALERTS_ROOT_ROUTE: TRoute = {
  name: "Alerts",
  path: ALERTS_URL.ROOT,
  component: AlertsWorkspaceLayout,
  roles: [],
  routes: [
    {
      name: "Alert Queue",
      path: "",
      component: AlertsQueuePage,
      roles: [],
    },
    {
      name: "Alert History",
      path: "history",
      component: AlertsHistoryPage,
      roles: [],
    },
    {
      name: "Alert Analytics",
      path: "analytics",
      component: AlertsAnalyticsPage,
      roles: [],
    },
    {
      // Staff-only. The page itself renders the unauthorized state — the route
      // stays registered so a direct link explains itself rather than 404ing,
      // and the backend authorizes the endpoint regardless.
      name: "Alert Ingest Monitoring",
      path: "monitoring",
      component: AlertsMonitoringPage,
      roles: [],
    },
  ],
};

const ALERTS_ROUTES = {
  ALERTS_ROOT_ROUTE,
} as const;

export { ALERTS_URL, ALERTS_ROUTES };
